import Event from '../../core/Event';

export default class OrderSetBaseOnLiabilityRequested extends Event {
    public static type = 'OrderSetBaseOnLiabilityRequested';

    constructor() {
        super(OrderSetBaseOnLiabilityRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderSetBaseOnLiabilityRequested.ts